import { IconCheck, IconLayers, IconLock, IconMobile, IconUsers } from "./icons";
import Reveal from "./Reveal";

const TRUST_CARDS = [
  {
    icon: IconLayers,
    title: "ABDM-ready",
    desc: "ABHA-linked health records with consent-based sharing built into the platform.",
  },
  {
    icon: IconCheck,
    title: "HIPAA-aligned",
    desc: "Security practices aligned to HIPAA. BAA available for enterprise deployments.",
  },
  {
    icon: IconLock,
    title: "Encrypted + mobile",
    desc: "AES-256 in transit and at rest. Full workflow on desktop, tablet, and phone.",
  },
  {
    icon: IconUsers,
    title: "Role-based access",
    desc: "Doctor, nurse, desk, pharmacy, and admin — each role sees only what they need.",
  },
  {
    icon: IconMobile,
    title: "Operate anywhere",
    desc: "Ward rounds, front desk, and follow-ups — same chart on every device.",
  },
];

export default function SecurityTrust() {
  return (
    <section id="security" className="security-trust-section security-dark" aria-labelledby="security-heading">
      <div className="wrap">
        <Reveal>
          <span className="kicker">Security & access</span>
          <h2 className="section-title" id="security-heading">
            Built for clinics that take <b>trust seriously</b>
          </h2>
          <p className="section-lede">
            ABDM-ready, HIPAA-aligned, encrypted by default — with role-based access on mobile and desktop.
          </p>
        </Reveal>

        <Reveal as="div" className="trust-grid trust-grid-dark reveal-stagger">
          {TRUST_CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <article className="trust-card trust-card-dark" key={card.title}>
                <span className="trust-card-icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </article>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
}
